import React from 'react';

import { Swiper, Image, AutoCenter, Footer, List } from 'antd-mobile'
// import dayjs from 'dayjs';

import './index.scss';
import { createFromIconfontCN } from '@ant-design/icons';


const Atest01 = () => {
    // const date = dayjs();
  


    const token = JSON.parse(localStorage.getItem('cx315_token'))


    const MyIcon = createFromIconfontCN({
        scriptUrl: '//at.alicdn.com/t/c/font_5169486_apm3rxyzekh.js', // 在 iconfont.cn 上生成
    });


    // p_type_2026

    return <>

        <Swiper autoplay>
            <Swiper.Item key={`topimgmr1`}><Image src='https://shengcong.sh3.ikuai7.com/ap_res/v3/1000_1777352812#sc' /></Swiper.Item>
        </Swiper>

        <div style={{
            width: '100%',
            height: '39px',
            background: '#02af6f',
            backgroundImage: 'linear-gradient(to right, #0958d9, #fff)',
            color: '#FFF',
            lineHeight: '39px',
            paddingLeft: '7px',
            fontSize: '24px',
        }}>

            防伪溯源信息
        </div>


        <AutoCenter style={{ marginTop: '20px', fontSize: '24px' }}>{token.dbcode}</AutoCenter>
        <AutoCenter style={{ marginTop: '20px', fontSize: '98px' }}><MyIcon type="icon-zhengpin" className='iconclass'

        /></AutoCenter>

        <div className='fwnr'>
            您好，你所查询的是河南亨特彩铝科技有限公司出品的系列产品，品质保证，请放心使用！此防伪码已被查询{token.qjson[0].Browse_num}次，首次查询时间为：{token.qjson[0].fsmt}；

        </div>



        <div style={{
            marginTop: '21px',
            width: '100%',
            height: '39px',
            background: '#02af6f',
            backgroundImage: 'linear-gradient(to right, #0958d9, #fff)',
            color: '#FFF',
            lineHeight: '39px',
            paddingLeft: '7px',
            fontSize: '24px',
        }}>

            产品信息
        </div>


        <List style={{ '--font-size': '1em', '--padding-left': '5px' }}>
            { token &&  token.cpjson.mjson[0] && token.cpjson.mjson[0].list.map((e, t) => <List.Item extra={e.second} key={`sc${t}`}> {e.first}</List.Item>)}
        </List>


        <Footer label='没有更多了'></Footer>


    </>
}

export default Atest01;